export enum MessageReceiver {
  USER = 'User',
  DRIVER = 'Driver',
  EXPEDITION = 'Expedition',
  SERVICE = 'Service',
  TOWN = 'Town',
}